import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-771aff50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data-relevance" }

import { useDateFormat } from '@vueuse/core'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DataRelevance',
  props: {
    dateInMs: null
  },
  setup(__props: any) {

const props = __props as {
	dateInMs?: number
};

const formattedDate = computed(() => {
	if (!props.dateInMs) {
		const oneDayInMs = 24 * 60 * 60 * 1000
		const yesterdayInMs = new Date().getTime() - oneDayInMs
		return useDateFormat(yesterdayInMs, 'DD.MM.YYYY').value
	}
	return useDateFormat(props.dateInMs, 'DD.MM.YYYY').value
})


// export default defineComponent({
// 	props: {
// 		date: {
// 			type: String,
// 			default() {
// 				return `${normalizeDateString(yesterdayObject.date)}.${normalizeDateString(yesterdayObject.months + 1)}.${yesterdayObject.years}`
// 			}
// 		}
// 	}
// })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, "Данные актуальны на " + _toDisplayString(_unref(formattedDate)), 1))
}
}

})